/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
  {
    path: '/action_plans',
    component: () => import('@/layout/Default.vue'),
    children: [
      {
        path: 'create',
        name: 'create_action_plan',
        component: () => import('./pages/Create.vue'),
        meta: {
          title: "Criar plano de ação",
          breadcrumbs: [
            { label: "Planos Municipais", to: "planos_estrategicos_list" },
            { label: "Novo plano de ação", to: "create_action_plan", active: true }
          ]
        }
      },
      {
        path: 'edit/:id',
        name: 'edit_action_plan',
        component: () => import('./pages/Edit.vue'),
        meta: {
          title: "Editar plano de ação",
          breadcrumbs: [
            { label: "Planos Municipais", to: "planos_estrategicos_list" },
            { label: "Plano de ação", to: "show_action_plan" },
            { label: "Editar", to: "edit_action_plan", active: true }
          ]
        }
      },
      {
        path: 'show/:id',
        name: 'show_action_plan',
        component: () => import('./pages/Show.vue'),
        meta: {
          title: "Plano de ação",
          breadcrumbs: [
            { label: "Planos Municipais", to: "planos_estrategicos_list" },
            { label: "Plano de ação", to: "show_action_plan", active: true }
          ]
        }
      },
      {
        path: "show/:id/item/:itemId",
        name: "show_action_plan_item",
        component: () => import("./pages/ShowActionModalPage.vue"),
        meta: {
          title: "Ação | Visualizar",
          breadcrumbs: [
            { label: "Planos Municipais", to: "planos_estrategicos_list" },
            { label: "Plano de ação", to: "show_action_plan" },
            { label: "Ação", to: "show_action_plan_item", active: true },
          ],
        },
      },
    ]
  },
  {
    path: '/acoes',
    component: () => import('@/layout/Default.vue'),
    children: [
      {
        path: '',
        name: 'acoes_list',
        component: () => import('./pages/ActionsList.vue'),
        meta: {
          title: "Listagem de Ações",
          breadcrumbs: [
            { label: "Listagem de Ações", to: "acoes_list", active: true }
          ]
        }
      }
    ]
  }
];
